export default __webpack_public_path__ + "locales/hy-AM/DeleteProfileEverDialog.json?hash=fa614e76a7b0c3a5501fc03ed4601075";